import {
    InsightPreviewFileFormats,
    MediaFileFormats,
} from "../types/insightPreviewFileFormats";
import { MarketingNarrativeFileFormats } from "../types/marketingNarrativeFileFormats";

export type AllInsightFileFormats = MarketingNarrativeFileFormats;

export const insightPreviewFileFormatMapper: {
    [key in AllInsightFileFormats]: InsightPreviewFileFormats;
} = {
    [MarketingNarrativeFileFormats.JPG]: InsightPreviewFileFormats.JPG,
    [MarketingNarrativeFileFormats.PNG]: InsightPreviewFileFormats.PNG,
    [MarketingNarrativeFileFormats.MP4]: InsightPreviewFileFormats.MP4,
    [MarketingNarrativeFileFormats.PDF]: InsightPreviewFileFormats.PDF,
    [MarketingNarrativeFileFormats.PPTX]: InsightPreviewFileFormats.PDF,
    [MarketingNarrativeFileFormats.DOCX]: InsightPreviewFileFormats.PDF,
    [MarketingNarrativeFileFormats.XLSX]: InsightPreviewFileFormats.PDF,
};

const pdfShareableFileFormats: AllInsightFileFormats[] = [
    MarketingNarrativeFileFormats.DOCX,
    MarketingNarrativeFileFormats.PPTX,
];

export const getInsightPreviewFileFormat = (
    fileFormat?: AllInsightFileFormats | string,
): InsightPreviewFileFormats => {
    switch (fileFormat) {
        case MarketingNarrativeFileFormats.JPG:
            return InsightPreviewFileFormats.JPG;
        case MarketingNarrativeFileFormats.PNG:
            return InsightPreviewFileFormats.PNG;
        case MarketingNarrativeFileFormats.MP4:
            return InsightPreviewFileFormats.MP4;
        default:
            return InsightPreviewFileFormats.PDF;
    }
};

export const isMediaFile = (
    previewFileFormat: InsightPreviewFileFormats | AllInsightFileFormats,
): boolean => {
    return Object.values<string>(MediaFileFormats).includes(previewFileFormat);
};

export const isShareableAsPdf = (
    fileFormat: AllInsightFileFormats,
): boolean => {
    return pdfShareableFileFormats.indexOf(fileFormat) > -1;
};
